import { render } from "./StoryChangeCompareItem.vue?vue&type=template&id=2b975c82&scoped=true"
import script from "./StoryChangeCompareItem.vue?vue&type=script&lang=js"
export * from "./StoryChangeCompareItem.vue?vue&type=script&lang=js"

import "./StoryChangeCompareItem.vue?vue&type=style&index=0&id=2b975c82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b975c82"]])

export default __exports__